export const inputs = [
  {
    advanced: false,
    type: 'input',
    id: 'name',
    label: 'Nome',
    value: ''
  }
];